import React, {useContext, useEffect, useState} from "react";
import TrackVASContext from "../../TrackVASContext";
import {PageTitle} from "../../../_metronic/layout/core";
import {headerSortingClasses, sortCaret,} from "../generic/table/pagination/TableSortingHelpers";
import {GenericTable} from "../generic/table/GenericTable";
import {defaultList} from "../generic/InitialStates";
import {ENTITY_ID_PERMISSIONS} from "../generic/Constants";
import {RoleAddEditDialog} from "./RoleAddEditDialog";
import {HeaderColumnFormatter} from "../../column-formatters/HeaderColumnFormatter";

export function PermissionsPage() {
    const myData = useContext(TrackVASContext);
    const [reload, setReload] = useState(1);
    const [pageLoadComplete, setPageLoadComplete] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModelId, setShowModelId] = useState(null);

    const profileBreadCrumbs = [
        {
            title: "Home",
            path: "/dashboard",
            isSeparator: false,
            isActive: false,
        },
        {
            title: "",
            path: "",
            isSeparator: true,
            isActive: false,
        },
    ];

    const columns = [
        {
            dataField: "name",
            text: "Name",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            hidden: false,
            formatter: HeaderColumnFormatter
        },
        {
            dataField: "description",
            text: "Description",
            sort: true,
            sortCaret: sortCaret,
            headerSortingClasses,
            hidden: false,
        }
    ];

    function reloadData() {
        setReload(reload + 1);
    }

    function addButtonClicked() {
        setShowModelId(null);
        setShowModal(true);
    }

    const handleClose = () => setShowModal(false);

    useEffect(() => {
        myData.setBaseData({
            toolBarButtons: [],
        });

        setPageLoadComplete(true);

        return () => {
            myData.setBaseData({
                toolBarButtons: []
            });
        };
    }, []);

    return (
        <>
            <PageTitle breadcrumbs={profileBreadCrumbs}>Permissions</PageTitle>
            <div className="card card-body">
                {pageLoadComplete && (
                    <GenericTable
                        reload={reload}
                        defaultData={defaultList}
                        columns={columns}
                        entityId={ENTITY_ID_PERMISSIONS}
                    />
                )}
            </div>
            <RoleAddEditDialog show={showModal} handleClose={handleClose} id={showModelId} reloadData={reloadData}/>
        </>
    );
}
